import { isPartnerDomain, isUserappDomain } from './currentDomain'

const getHostUrl = (): string => {
    if (isUserappDomain) {
        return location.origin + '/userapp'
    } else if (isPartnerDomain) {
        return location.origin + '/partner'
    } else {
        return location.origin + '/admin'
    }
}

export default getHostUrl
